import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useExternalHref } from '../useExternalHref';
import { msgs } from './messages';

export const useGeneralLinks = () => {
  const intl = useIntl();

  const memriseAboutUsHref = useExternalHref({
    linkType: 'memrise-about-us',
  });

  const memriseBlogHref = useExternalHref({
    linkType: 'memrise-blog',
  });

  const memriseContactUsHref = useExternalHref({
    linkType: 'memrise-contact-us',
  });

  const memriseEngineeringBlogHref = useExternalHref({
    linkType: 'memrise-engineering-blog',
  });

  const memriseFAQHref = useExternalHref({
    linkType: 'memrise-help',
  });

  const memriseJobsHref = useExternalHref({
    linkType: 'memrise-jobs',
  });

  const memriseLearnLanguageCustomHref = useExternalHref({
    linkType: 'memrise-learn-language-custom',
  });

  const memriseMobileAppHref = useExternalHref({
    linkType: 'memrise-mobile-app',
  });

  const memrisePhilosophyHref = useExternalHref({
    linkType: 'memrise-philosophy',
  });

  const memrisePhrasebooksHref = useExternalHref({
    linkType: 'memrise-phrasebooks',
  });

  const memriseTeamHref = useExternalHref({
    linkType: 'memrise-team',
  });

  const plansLink = useExternalHref({ linkType: 'memrise-payment-plans' });

  return useMemo(
    () =>
      [
        memriseAboutUsHref && {
          href: memriseAboutUsHref,
          text: intl.formatMessage(msgs.aboutUs),
        },
        memriseContactUsHref && {
          href: memriseContactUsHref,
          text: intl.formatMessage(msgs.contactUs),
        },
        memriseFAQHref && {
          href: memriseFAQHref,
          text: intl.formatMessage(msgs.faq),
        },
        memriseMobileAppHref && {
          href: memriseMobileAppHref,
          text: intl.formatMessage(msgs.mobileApp),
        },
        plansLink && {
          href: plansLink,
          text: intl.formatMessage(msgs.plans),
        },
        memrisePhilosophyHref && {
          href: memrisePhilosophyHref,
          text: intl.formatMessage(msgs.philosophy),
        },
        memriseTeamHref && {
          href: memriseTeamHref,
          text: intl.formatMessage(msgs.team),
        },
        memriseBlogHref && {
          href: memriseBlogHref,
          text: intl.formatMessage(msgs.blog),
        },
        memriseJobsHref && {
          href: memriseJobsHref,
          text: intl.formatMessage(msgs.jobs),
        },
        memriseEngineeringBlogHref && {
          href: memriseEngineeringBlogHref,
          text: intl.formatMessage(msgs.engineeringBlog),
        },
        memriseLearnLanguageCustomHref && {
          href: memriseLearnLanguageCustomHref,
          text: intl.formatMessage(msgs.learnLanguage),
        },
        memrisePhrasebooksHref && {
          href: memrisePhrasebooksHref,
          text: intl.formatMessage(msgs.phrasebooks),
        },
      ].filter(Boolean) as { href: string; text: string }[],
    [
      intl,
      memriseAboutUsHref,
      memriseBlogHref,
      memriseContactUsHref,
      memriseEngineeringBlogHref,
      memriseFAQHref,
      memriseJobsHref,
      memriseLearnLanguageCustomHref,
      memriseMobileAppHref,
      memrisePhilosophyHref,
      memrisePhrasebooksHref,
      memriseTeamHref,
      plansLink,
    ],
  );
};
